module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-3.11b8e657.jpg";